import ContextMenu from '../ContextMenu';
import TitleAuthor from './TitleInfo/TitleAuthor';
import TitleEdition from './TitleInfo/TitleEdition';
import TitleName from './TitleInfo/TitleName';
import TitleFormatBadge from './TitleInfo/TitleFormatBadge';
import TitleSeries from './TitleInfo/TitleSeries';
import TitlePreRelease from './TitleInfo/TitlePreRelease';
import CopiesAvailable from './TitleInfo/CopiesAvailable';

export default class TitleInfoListView extends Backbone.View {
    get className() {
        return 'title-info';
    }

    constructor() {
        super(...arguments);
        this._views = [];

        this.render();
    }

    _reset() {
        this._views.forEach((view) => view.remove());
        this._views = [];
    }

    remove() {
        this._reset();
        super.remove();
    }

    render() {
        this._reset();

        this._views.push(
            (this.contextMenu = new ContextMenu({ model: this.model }))
        );

        if (this.model.isMagazine) {
            this._views.push(
                (this.titleEdition = new TitleEdition({ model: this.model }))
            );
        } else {
            this._views.push(
                (this.titleAuthor = new TitleAuthor({ model: this.model }))
            );
        }
        this._views.push(
            (this.titleName = new TitleName({ model: this.model }))
        );
        this._views.push(
            (this.titleSeries = new TitleSeries({ model: this.model }))
        );
        this._views.push(
            (this.titleFormatBade = new TitleFormatBadge({
                typeId: this.model.get('type').id,
            }))
        );
        this._views.push(
            (this.titlePreRelease = new TitlePreRelease({ model: this.model }))
        );

        if (!window.featureManager.isEnabled('sampleOnlyMode')) {
            this._views.push(
                (this.copiesAvailable = new CopiesAvailable({
                    model: this.model,
                }))
            );
        }

        this.$el.empty();
        this.$el.append(
            this.titleName.$el,
            this.contextMenu.$el.addClass('text-right'),
            this.titleSeries.$el,
            this.model.isMagazine
                ? this.titleEdition.$el
                : this.titleAuthor.$el,
            this.titleFormatBade.$el
        );

        if (!!this.model.get('isPreReleaseTitle')) {
            this.$el.append(this.titlePreRelease.$el);
        }

        if (!window.featureManager.isEnabled('sampleOnlyMode')) {
            this.$el.append(this.copiesAvailable.$el);
        }
    }
}
